import { memo, useEffect, useState } from "react";
import { styled } from 'styled-components';
import { colors, device } from "../styles/stylesConfig";
import MenuButton from "./MenuButton";
import Menu from "./Menu";
import { useAnimations } from "../effects/Effects";
import { useLogEvent } from "../hooks/useLogEvent";
import AppLogoComponent from "./AppLogoComponent";
import { useTranslation } from "react-i18next";

const Container = styled.div`
    width: 100%;
    height: 100px;
    position: fixed;
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    z-index: 3;
    backdrop-filter: blur(0px);
    background-color: transparent;
    padding: 7.3px 0px;
    transition: all 0.75s ease-in;


    @media ${device.lg} {
        height: 70px;
        padding: 7.3px 0px;
    }

    &.active {
        background: rgba(18, 34, 46, 0.5);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
        backdrop-filter: blur(5px);
    }
`

const MenuDiv = styled.div`
    width: 90%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    justify-content: center;

    @media ${device.lg} {
    grid-template-columns: repeat(2, 1fr);

        width: 90%;
        height: auto;
        flex-direction: row;
    }

    & > button:last-of-type {
        padding: 10px 20px;

        &::before {
            background-color: transparent;
        }
    }
`

const NavDiv = styled.div`
    width: 500px;
    display: flex;
    color: black;
    align-items: center;
    justify-content: space-between;

    @media ${device.lg} {
        width: 500px;
    }
    
    @media ${device.lg} {
        visibility: hidden;
        position: absolute;
    }
`

const NavButton = styled.button`
    color: ${colors.primary};
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 1px;
    padding: 10px 10px;
    border-radius: 5px;
    cursor: pointer;
    position: relative;
    transition: all 0.3s ease-in-out;

    @media ${device.lg} {
        visibility: hidden;
        position: absolute;
    }

    &::before {
        content: '';
        height: 5px;
        width: 0%;
        bottom: 0;
        left: 0;
        position: absolute;
        background-color: #fff;
        transition: width 0.3s ease;
        border-radius: 50px;
    }



    &:focus,
    &:hover {
        outline: none;

        &::before {
            width: 100%;
        }

        & > div {
            visibility: visible !important;
        }
        
    }

`

export const HeaderComponent = () => {

    const { t } = useTranslation();

    const [showMenu, setShowMenu] = useState(false);

    const [blur, setBlur] = useState(false);

    const {
        handleClickGoHome,
        handleClickGoServices,
        handleClickGoProducts,
        handleClickGoAbout,
    } = useAnimations()

    const { handleLogEvent } = useLogEvent();

    const transitionNavBar = () => {

        if (window.scrollY > 50) {
            setBlur(true);
        } else {
            setBlur(false);
        }

    }

    useEffect(() => {

        transitionNavBar()

        window.addEventListener('scroll', transitionNavBar);

        return () => window.removeEventListener('scroll', transitionNavBar);

    }, []);

    return (

        <Container className={`${blur && "active"}`}>

            <MenuDiv>

                <AppLogoComponent />

                <NavDiv>

                    <NavButton onClick={async (e: any) => {

                        handleClickGoHome();

                        handleLogEvent('click_boton_inicio_menu');

                        e.target?.blur()

                    }}>
                        {t('header.home')}
                    </NavButton>

                    <NavButton onClick={async (e: any) => {

                        handleClickGoServices();

                        handleLogEvent('click_boton_servicios_menu');

                        e.target?.blur()

                    }}>
                        {t('header.services')}
                    </NavButton>

                    <NavButton onClick={async (e: any) => {

                        handleClickGoProducts()

                        handleLogEvent('click_boton_productos_menu');

                        e.target?.blur()

                    }}>
                        {t('header.products')}
                    </NavButton>

                    <NavButton onClick={async (e: any) => {

                        handleClickGoAbout();

                        handleLogEvent('click_boton_nosotros_menu');

                        e.target?.blur()

                    }}>
                        {t('header.about')}
                    </NavButton>


                </NavDiv>

                <NavButton
                    style={{ color: '#fff', backgroundColor: colors.primary, width: 'fit-content', justifySelf: 'end' }}
                    onClick={async (e: any) => {

                        let message = t('wsp.link.number') + t('wsp.link.message');

                        handleLogEvent('click_boton_contacto_menu');

                        e.target?.blur()

                        window.open(message, 'blank')

                    }}>
                    {t('header.contact')}
                </NavButton>

                <MenuButton showMenu={showMenu} setShowMenu={setShowMenu} />

            </MenuDiv>

            <Menu showMenu={showMenu} setShowMenu={setShowMenu} />

        </Container>

    )
}

const Header = memo(HeaderComponent);

export default Header;
